import $ from 'jquery'

const $body = $('body')
const $toggle = $('[data-toggle]')

export function init() {
  $body.removeClass('open')
  $toggle.on('click touchstart', (event) => {
    event.preventDefault()
    event.stopPropagation()
    $body.toggleClass('open')
  })
}
